import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import AdmissionSidebar from "./components/AdmissionSidebar";

export default class PHD extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Admission" image="banners/banner-admission.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Ph.D Programs</h4>
                    </div>
                    <div className="ttm-service-description">
                      <table class="table">
                        <thead
                          style={{ backgroundColor: "#98002e", color: "white" }}
                        >
                          <tr>
                            <th style={{ width: "4%" }}>Sl No</th>
                            <th style={{ width: "23%" }}>
                              Departments offering Ph.D Programs
                            </th>
                            <th style={{ width: "20%" }}>Guide Name</th>
                            <th style={{ width: "37%" }}>Area</th>
                            <th style={{ width: "8%" }}>Ph.D Pursuing</th>
                            <th style={{ width: "7%" }}>No of vacancies</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th>1</th>
                            <th>CSE </th>
                            <td>DR. Asha T</td>
                            <td>
                              Data Mining, Soft computing, Machine learning
                            </td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>2</th>
                            <th>CSE </th>
                            <td>Dr. D. G. Jyothi</td>
                            <td>
                              Delay tolerant networks, Artificial Intelligence &
                              Machine Learning and Blockchain
                            </td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>3</th>
                            <th>CSE </th>
                            <td>Dr. Suneetha K. R</td>
                            <td>Web mining</td>
                            <td>03</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>4</th>
                            <th>AI & ML </th>
                            <td>Dr. Kempanna M</td>
                            <td>
                              Delay tolerant networks, Artificial Intelligence &
                              Machine Learning and Blockchain
                            </td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>5</th>
                            <th>AI & ML </th>
                            <td>Dr. D. G. Jyothi</td>
                            <td>Network security</td>
                            <td>03</td>
                            <td>00</td>
                          </tr>
                          <tr>
                            <th>3</th>
                            <th>CSE </th>
                            <td>Dr. Suneetha K. R</td>
                            <td>Web mining</td>
                            <td>03</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>4</th>
                            <th>AI & ML </th>
                            <td>Dr. Kempanna M</td>
                            <td>
                              Delay tolerant networks, Artificial Intelligence &
                              Machine Learning and Blockchain
                            </td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>5</th>
                            <th>AI & ML </th>
                            <td>Dr. D. G. Jyothi</td>
                            <td>Network security</td>
                            <td>03</td>
                            <td>00</td>
                          </tr>
                          <tr>
                            <th>6</th>
                            <tH>ECE </tH>
                            <td>Dr M N Sreeranga Raju</td>
                            <td>Wireless Communication & Networks</td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>7</th>
                            <tH>ECE </tH>
                            <td>Dr Hemath Kumar A R</td>
                            <td>
                              Sensor Networks / Mobile Networks / Wireless
                              Networks
                            </td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>8</th>
                            <tH>ECE </tH>
                            <td>Dr Vijayaprakash A M</td>
                            <td>VLSI Design, Image and Video processing</td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>9</th>
                            <tH>ECE </tH>
                            <td>Dr C Byrareddy</td>
                            <td>Wireless Communication & Antennas</td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>10</th>
                            <tH>ECE </tH>
                            <td>Dr A B Kalpana</td>
                            <td>
                              VLSI Design and Embedded Systems, Communication
                              and Image Processing
                            </td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>11</th>
                            <tH>ECE </tH>
                            <td>Dr Narendra C P</td>
                            <td>DSP and Image Processing</td>
                            <td>00</td>
                            <td>06</td>
                          </tr>
                          <tr>
                            <th>8</th>
                            <tH>EIE </tH>
                            <td>Dr.M B Meenavathi</td>
                            <td>Digital Image Processing</td>
                            <td>02</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>9</th>
                            <tH>EIE </tH>
                            <td>Dr. H N Suresh</td>
                            <td>Signal Processing</td>
                            <td>02</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>10</th>
                            <tH>EIE </tH>
                            <td>Dr. Ashwathappa P</td>
                            <td>Bio Medical Signalling</td>
                            <td>00</td>
                            <td>06</td>
                          </tr>
                          <tr>
                            <th>11</th>
                            <tH>EIE </tH>
                            <td>Dr. Sudha L K</td>
                            <td>
                              Electronics & Communication (Nanotechnology)
                            </td>
                            <td>02</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>12</th>
                            <tH>ETE </tH>
                            <td>Dr. S. Shanthala</td>
                            <td>Low Power VLSI</td>
                            <td>03</td>
                            <td>05</td>
                          </tr>
                          <tr>
                            <th>13</th>
                            <th>ETE </th>
                            <td>Dr. M. Rajeshwari</td>
                            <td>
                              Electronics & Communication (Nanotechnology)
                            </td>
                            <td>03</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>14</th>
                            <th>ISE </th>
                            <td>Dr.J.Prakash</td>
                            <td>Digital Image Processing</td>
                            <td>00</td>
                            <td>08</td>
                          </tr>
                          <tr>
                            <th>15</th>
                            <th>ISE </th>
                            <td>Dr.R.Nagaraja</td>
                            <td>Computer Networks</td>
                            <td>05</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>16</th>
                            <th>Mathematics </th>
                            <td>Dr. Roopa K M</td>
                            <td>
                              Fluid Mechanics, Transportation GIS, Mathematical
                              Modelling and Network Systems
                            </td>
                            <td>02</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>17</th>
                            <th>Mathematics </th>
                            <td>Dr. Dhananjaya M</td>
                            <td>Fluid Mechanics</td>
                            <td>02</td>
                            <td>00</td>
                          </tr>
                          <tr>
                            <th>18</th>
                            <th>Mathematics </th>
                            <td>Dr. K. Manjula</td>
                            <td>Combinatorial Graph Theory</td>
                            <td>01</td>
                            <td>00</td>
                          </tr>
                          <tr>
                            <th>19</th>
                            <th>EEE </th>
                            <td>Dr.Pramila</td>
                            <td>Power Systems </td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>20</th>
                            <th>EEE </th>
                            <td>Dr. H B Nagesh</td>
                            <td>Power Systems</td>
                            <td>02</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>21</th>
                            <th>Physics </th>
                            <td>Dr. Nagaraja D</td>
                            <td>Spectroscopy, material science, shock waves</td>
                            <td>03</td>
                            <td>05</td>
                          </tr>

                          <tr>
                            <th>23</th>
                            <th>Physics </th>
                            <td>Dr. Geethanjali H. S</td>
                            <td>
                              Fluorescence spectroscopy, Nano science and
                              Technology, material Science{" "}
                            </td>
                            <td>03</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>24</th>
                            <th>Physics </th>
                            <td>Dr. Raghavendra U. P</td>
                            <td>
                              Molecular Spectroscopy, Nanoscience and Material
                              science
                            </td>
                            <td>02</td>
                            <td>02</td>
                          </tr>
                          <tr>
                            <th>25</th>
                            <th>Physics </th>
                            <td>Dr. Chaluvaraju B. V</td>
                            <td>
                              Conducting Polymer Composites, Nanomaterials and
                              Materials Science
                            </td>
                            <td>02</td>
                            <td>02</td>
                          </tr>
                          <tr>
                            <th>26</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Sreerama Reddy</td>
                            <td>Heat Transfer, Cryogenics</td>
                            <td>05</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>27</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Ravi Kumar B N</td>
                            <td>Polymer composites</td>
                            <td>00</td>
                            <td>08</td>
                          </tr>
                          <tr>
                            <th>28</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Ashwath</td>
                            <td>Polymer Composites</td>
                            <td>05</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>29</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Reddappa H N</td>
                            <td>Polymer Composites</td>
                            <td>06</td>
                            <td>00</td>
                          </tr>
                          <tr>
                            <th>30</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Satish N</td>
                            <td>Polymer Composites</td>
                            <td>01</td>
                            <td>07</td>
                          </tr>
                          <tr>
                            <th>31</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Honnegowda</td>
                            <td>Bio Diesel</td>
                            <td>04</td>
                            <td>02</td>
                          </tr>
                          <tr>
                            <th>32</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Manjunath M C </td>
                            <td>Bio Diesel</td>
                            <td>00</td>
                            <td>06</td>
                          </tr>
                          <tr>
                            <th>33</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Praveen Kumar M</td>
                            <td>Heat Transfer</td>
                            <td>00</td>
                            <td>06</td>
                          </tr>
                          <tr>
                            <th>34</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Nagaraja C Reddy</td>
                            <td>Metal Coatings</td>
                            <td>00</td>
                            <td>06</td>
                          </tr>
                          <tr>
                            <th>35</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Babu E R</td>
                            <td>Heat Transfer, Composite Composites</td>
                            <td>01</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>36</th>
                            <th>Mechanical Engineering </th>
                            <td>Dr. Chandrashekar A</td>
                            <td>Composite Composites</td>
                            <td>00</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>37</th>
                            <th>Chemistry </th>
                            <td>Dr. Chandra Shekara. B. M. </td>
                            <td>
                              Heterogeneous Catalysis and Material Science.{" "}
                            </td>
                            <td>02</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>38</th>
                            <th>Chemistry </th>
                            <td>Dr. Prakruthi. H. R. </td>
                            <td>
                              Heterogeneous Catalysis, Adsorption and Material
                              Science.{" "}
                            </td>
                            <td>01</td>
                            <td>01</td>
                          </tr>
                          <tr>
                            <th>39</th>
                            <th>Chemistry </th>
                            <td>Dr. Venkatesha </td>
                            <td>
                              Heterogeneous catalysis and Nano materials.{" "}
                            </td>
                            <td>00</td>
                            <td>02</td>
                          </tr>
                          <tr>
                            <th>40</th>
                            <th>Civil Engineering </th>
                            <td>Dr. H B Balakrishna</td>
                            <td>
                              Water Resource, Remote Sensing and GIS,
                              Environmental Engineering
                            </td>
                            <td>05</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>41</th>
                            <th>Civil Engineering </th>
                            <td>Dr. H N Jagannatha Reddy</td>
                            <td>Structural Engineering</td>
                            <td>05</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>42</th>
                            <th>Civil Engineering </th>
                            <td>Dr. P M Ravindra </td>
                            <td>Structural Engineering </td>
                            <td>04</td>
                            <td>04</td>
                          </tr>
                          <tr>
                            <th>43</th>
                            <th>Civil engineering </th>
                            <td>Dr. Rudre Gowda </td>
                            <td>Environmental Engineering</td>
                            <td>00</td>
                            <td>03</td>
                          </tr>
                          <tr>
                            <th>44</th>
                            <th>Civil Engineering </th>
                            <td>Dr.B S Putte Gowda </td>
                            <td>Concrete technology Structural Engineering </td>
                            <td>01</td>
                            <td>02</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Admission process and eligibility
                      </h4>
                    </div>
                  </div>
                  <p className="justify">
                    Bangalore institute of technology has established research
                    and development (R & D) centers recognized by VTU in all the
                    thirteen departments. These R & D centers offer full time
                    and part time Ph.D programs and MSc Engineering (Research)
                    programs for eligible research scholars. The admission
                    procedure and other details obtained from the research
                    coordinators of the respective department or may visit VTU
                    website using the link – VTU Research. Fellowships for the
                    research scholars to pursue full time research program are
                    available. The eligibility criteria and other details for
                    procuring financial aid are available here (JNANA-YANNA)
                  </p>
                  <br />
                  <p className="justify">
                    Candidates seeking admission to Ph.D program are required to
                    appear for VTU Eligibility Test with a minimum 55% aggregate
                    marks in M.Tech degree under respective specialization.
                    Candidates will be assessed on the basis of entrance test
                    score and presentation on their research topic in front of
                    the VTU identified panel members. The one who qualifies
                    successfully will be allowed for admission.{" "}
                    <b>
                      For more information, please visit VTU website:
                      <a href="www.vtu.ac.in" target="_blank">
                        {" "}
                        www.vtu.ac.in{" "}
                      </a>
                    </b>
                  </p>
                </div>

                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">
                      Online Fee Payment Conditions and Refund Policies
                    </h4>
                  </div>

                  <div>
                    <h6 className="text-secondary font-weight-bold">
                      Online Fee Payment Conditions
                    </h6>
                    <br />
                    <p className="text-muted">
                      <strong>As per the guidelines of AICTE and VTU.</strong>
                    </p>
                    <br />
                    <div className="mb-3">
                      <h6 className="font-weight-bold">Payment Method</h6>
                      <ul className="list-group" style={{ marginTop: "12px" }}>
                        <li className="list-group-item">
                          Payments can usually be made through debit/credit
                          cards, bank transfers, UPI, or integrated third-party
                          payment gateways.
                        </li>
                        <li className="list-group-item">
                          Ensure that the payment method is accepted by the
                          platform or service provider.
                        </li>
                      </ul>
                    </div>

                    <div className="mb-3">
                      <h6 className="font-weight-bold">Timing of Payment</h6>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ marginTop: "12px" }}
                        >
                          Payments may be due by a specific date. Late payments
                          might incur penalties or interest charges.
                        </li>
                        <li className="list-group-item">
                          Some platforms may allow for automatic payment
                          processing, and others may require manual action.
                        </li>
                      </ul>
                    </div>

                    <div className="mb-3">
                      <h6 className="font-weight-bold">
                        Confirmation of Payment
                      </h6>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ marginTop: "12px" }}
                        >
                          Mobile number entered on the payment should be
                          correct, and the same will be used for verifying
                          payment status.
                        </li>
                        <li className="list-group-item">
                          After a successful transaction, a confirmation receipt
                          or transaction ID is often sent to the user's
                          registered email or phone number.
                        </li>
                        <li className="list-group-item">
                          It's essential to keep this confirmation as proof of
                          payment.
                        </li>
                        <li className="list-group-item">
                          The receipt can be downloaded or collect from the
                          college office.
                        </li>
                      </ul>
                    </div>

                    <div className="mb-3">
                      <h6
                        className="font-weight-bold"
                        style={{ marginTop: "12px" }}
                      >
                        Security Measures
                      </h6>
                      <ul className="list-group" style={{ marginTop: "12px" }}>
                        <li className="list-group-item">
                          Secure payment gateways should be in place to ensure
                          that your payment information remains private and
                          protected.
                        </li>
                      </ul>
                    </div>

                    <div className="mb-3">
                      <h6 className="font-weight-bold">
                        Charges & Additional Fees
                      </h6>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ marginTop: "12px" }}
                        >
                          Some services may charge transaction fees or
                          processing fees for using specific payment methods,
                          like credit cards or third-party payment services.
                        </li>
                        <li className="list-group-item">
                          Always check the total amount due, including any extra
                          charges.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div>
                    <h6 className="font-weight-bold">Refund Policies</h6>
                    <ul className="list-group">
                      <li
                        className="list-group-item"
                        style={{ marginTop: "12px" }}
                      >
                        Payments made through online are non-refundable.
                      </li>
                      <li className="list-group-item">
                        Once paid fees are neither refundable or adjustable
                        under any circumstances.
                      </li>
                      <li className="list-group-item">
                        We have a strict "no refund" policy for any kind of
                        payments.
                      </li>
                      <li className="list-group-item">
                        If there is a system error/duplicate payment/wrong
                        amount, the amount will be refunded by taking permission
                        from Rajya Vokkaligara Sangha (RVS).
                      </li>
                    </ul>
                  </div>

                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Terms & Conditions</h4>
                    </div>
                    <ul className="list-group">
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        These Terms and Conditions, along with the Privacy
                        Policy and other applicable terms ("Terms"), constitute
                        a binding agreement between RAJYA VOKKALIGARA SANGHA
                        ("Website Owner," "we," "us," or "our") and you ("you"
                        or "your"). These Terms govern your use of our website,
                        goods (if applicable), and services (collectively,
                        "Services").
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        By using our website and availing of our Services, you
                        confirm that you have read, understood, and accepted
                        these Terms (including the Privacy Policy). We reserve
                        the right to modify these Terms at any time without
                        prior notice. It is your responsibility to periodically
                        review them to stay informed of updates.
                      </li>

                      <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                        <h5>Terms of Use</h5>
                      </div>

                      <li className="list-group-item">
                        The use of this website or availing of our Services is
                        subject to the following conditions:
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        To access and use the Services, you agree to provide
                        true, accurate, and complete information during
                        registration and afterward. You are responsible for all
                        activities carried out using your registered account.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        Neither we nor third parties provide any warranty or
                        guarantee regarding the accuracy, timeliness,
                        performance, completeness, or suitability of the
                        information and materials available on this website or
                        through the Services for any specific purpose. You
                        acknowledge that such materials may contain inaccuracies
                        or errors, and we expressly exclude liability for any
                        such inaccuracies or errors to the fullest extent
                        permitted by law.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        You use our Services and website at your own risk and
                        discretion. You are responsible for independently
                        assessing and ensuring that the Services meet your
                        requirements.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        The contents of the website and the Services are
                        proprietary to us, and you do not have any intellectual
                        property rights, title, or interest in them.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        Unauthorized use of the website or Services may lead to
                        legal action against you under these Terms and
                        applicable laws.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        You agree to pay any charges associated with availing of
                        the Services, as applicable. You agree not to use the
                        website or Services for any unlawful, illegal, or
                        prohibited purpose under these Terms, Indian law, or any
                        other applicable laws.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        You acknowledge that this website and the Services may
                        contain links to third-party websites. Upon accessing
                        such links, you will be governed by the terms of use,
                        privacy policy, and other policies of those third-party
                        websites. We are not responsible for any content,
                        services, or transactions on such websites.
                      </li>

                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        By initiating a transaction for availing of the
                        Services, you enter into a legally binding and
                        enforceable contract with us.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        If we are unable to provide the requested Service, you
                        may be entitled to a refund. Refund eligibility and
                        timelines will be determined based on the specific
                        Service policies. If you fail to request a refund within
                        the stipulated time, you may no longer be eligible for
                        one.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        Any disputes arising from or in connection with these
                        Terms shall be subject to the exclusive jurisdiction of
                        the courts in Bangalore South, Karnataka.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        Any concerns or communications regarding these Terms
                        must be directed to us using the contact information
                        provided on this website.
                      </li>
                    </ul>
                  </div>

                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Privacy Policy</h4>
                    </div>
                    <ul className="list-group">
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        Your privacy is of utmost importance to Bangalore
                        Institute of Technology (BIT). We are committed to
                        protecting your personal information and ensuring
                        transparency in how we collect, use, and safeguard your
                        data. BIT does not give, share, sell, or transfer any
                        personal information to third parties without your
                        explicit consent.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Scope of this Privacy Policy:</strong> This
                        Privacy Policy applies to the information collected when
                        you visit the official website of Bangalore Institute of
                        Technology (
                        <a
                          href="http://www.bit-bangalore.edu.in"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          www.bit-bangalore.edu.in
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://bitwebserver.bittechlearn.online:8084"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://bitwebserver.bittechlearn.online:8084
                        </a>
                        ) and its associated sub-sites owned, managed, and
                        controlled by the institute. This policy explains how we
                        collect, process, and protect visitor information.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Browsing Behaviour:</strong> We track visitor
                        browsing patterns to analyse website usage and enhance
                        user experience. BIT deploys tools like Google Analytics
                        to collect anonymous statistics, which help improve the
                        website’s functionality. The following details may be
                        identified:
                        <ul>
                          <li>
                            Browser type and version (e.g., "Google Chrome
                            version Y" or "Mozilla Firefox version Y").
                          </li>
                          <li>
                            Operating system type (e.g., Windows, macOS, UNIX).
                          </li>
                          <li>
                            Date and time of website visits, pages viewed, and
                            referral sources.
                          </li>
                          <li>
                            No personally identifiable information is recorded
                            in this process.
                          </li>
                        </ul>
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Personal Information Collection:</strong> BIT
                        websites may request personally identifiable information
                        such as Name, Email ID, and Phone Number for the
                        following purposes:
                        <ul>
                          <li>
                            Event registrations (seminars, workshops, training
                            programs).
                          </li>
                          <li>
                            Online counselling, quizzes, or admission-related
                            inquiries.
                          </li>
                          <li>
                            Subscription to newsletters or other communication
                            materials.
                          </li>
                        </ul>
                        BIT does not sell, share, or disclose the information
                        provided on its websites to third parties, except when
                        legally required.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Email Communication:</strong> If you contact us
                        via email, your email address and message contents may
                        be used to respond to your inquiries. Please be aware
                        that email communication is not always secure; avoid
                        sharing sensitive personal details over email.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Interactive Forms:</strong> Some pages on our
                        website contain interactive forms where users can
                        voluntarily submit personal information for specific
                        purposes. This data is strictly used for the intended
                        purpose and is not shared with external entities.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Use of Cookies:</strong> BIT websites use
                        cookies to enhance user experience. The types of cookies
                        we use include:
                        <ul>
                          <li>
                            <strong>Necessary Cookies:</strong> Enable smooth
                            website functionality.
                          </li>
                          <li>
                            <strong>Performance Cookies:</strong> Gather
                            anonymous browsing data to improve website
                            performance.
                          </li>
                          <li>
                            <strong>Functional Cookies:</strong> Remember user
                            preferences and previous interactions to provide a
                            personalized experience.
                          </li>
                        </ul>
                        Users can disable cookies via browser settings, but this
                        may impact certain website functionalities.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Third-Party Links:</strong> BIT websites may
                        contain links to third-party websites. BIT is not
                        responsible for the privacy practices of these external
                        sites and encourages users to review their privacy
                        policies before providing personal information.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Contact Us:</strong> For inquiries regarding
                        this Privacy Policy, please contact:
                        <br />
                        Web Administrator
                        <br />
                        Bangalore Institute of Technology
                        <br />
                        K.R. Road, V.V. Pura,
                        <br />
                        Bangalore - 560004, Karnataka, India
                        <br />
                        Email: webmaster@bit-bangalore.edu.in
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textAlign: "justify" }}
                      >
                        This Privacy Policy is subject to periodic updates.
                        Continued use of BIT websites signifies your acceptance
                        of any modifications.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="section-title with-desc text-left clearfix">
                  <div
                    className="title-header paddingtop-2"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">Admission contact information</h4>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <ul className="ttm-pf-detailbox-list">
                      <li>
                        <i className="fa fa-user" />
                        <span>
                          {" "}
                          Principal - Bangalore Institute of Technology - K.R.
                          Road, V V Pura - Bangalore-560004
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-envelope" />
                        <span>
                          {" "}
                          Mail-ID :{" "}
                        </span>admission@bit-bangalore.edu.in{" "}
                      </li>
                      <li>
                        <i className="fas fa-phone" />
                        <span> Contact Number : </span>+91-9448512984,
                        +91-9448512954
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <h5>
                      For Admission queries please call during working hours
                    </h5>
                    <ul className="ttm-pf-detailbox-list">
                      <li>
                        <h6>
                          <span> Working Hours :</span>
                        </h6>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span> Monday to Fiday </span>9.00 AM - 5.00 PM /{" "}
                        <span> Saturday</span>9.00 AM - 2.00 PM{" "}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <AdmissionSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
